import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Portal from 'react-portal'

import { sendHoverSoundCommand, sendCancelClickSoundCommand } from '../../helpers/web_to_client'

import ButtonSmall from '../ButtonSmall/ButtonSmall'
import ButtonGroup from '../ButtonGroup/ButtonGroup'

import styles from './Dialog.css'

const ESC_KEY_CODE = 27

const propTypes = {
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    submitCaption: PropTypes.node.isRequired,
    closeCaption:  PropTypes.node.isRequired,
    isOpened: PropTypes.bool.isRequired,
    isDisabledSubmit: PropTypes.bool,
    isFocusOnSubmitBtn: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,

    /**
     * This prop used only for demonstration needs, so it is not needed in documentation
     *
     * @ignore
     */
    isDemo: PropTypes.bool,
}

class Dialog extends React.Component {
    constructor(props) {
        super(props)

        this.handleKeyDown = this.handleKeyDown.bind(this)
    }

    componentWillMount() {
        window.addEventListener('keydown', this.handleKeyDown, true)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true)
    }

    handleKeyDown(e) {
        if (this.props.isOpened) {
            if (e.keyCode === ESC_KEY_CODE) {
                this.props.onClose()
                e.stopImmediatePropagation()
            }
        }
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isOpened]: this.props.isOpened,
        })

        const dialog = (
            <div className={classNameBase}>
                <div className={styles.wrapper}>
                    <div className={styles.body}>
                        <div className={styles.background} />
                        <header className={styles.header}>
                            <p className={styles.title}>{this.props.title}</p>
                            <button
                                className={styles.close}
                                onClick={this.props.onClose}
                                onMouseDown={sendCancelClickSoundCommand}
                                onMouseEnter={sendHoverSoundCommand}
                            />
                        </header>
                        <main className={styles.content}>
                            {this.props.children}
                        </main>
                        <footer className={styles.footer}>
                            <ButtonGroup buttonsIndent="small">
                                <ButtonSmall
                                    isDisabled={this.props.isDisabledSubmit}
                                    isFocusOn={this.props.isFocusOnSubmitBtn}
                                    isJustified
                                    onClick={this.props.onSubmit}
                                >
                                    {this.props.submitCaption}
                                </ButtonSmall>

                                <ButtonSmall
                                    type={'secondary'}
                                    isCancel
                                    isJustified
                                    onClick={this.props.onClose}
                                >
                                    {this.props.closeCaption}
                                </ButtonSmall>
                            </ButtonGroup>
                        </footer>
                    </div>
                </div>
                <div className={styles.overlay} />
            </div>
        )

        return this.props.isDemo ? dialog : <Portal isOpened>{dialog}</Portal>
    }
}

Dialog.propTypes = propTypes

export default Dialog



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Dialog/Dialog.jsx